export const PD = {
  nav: "nav-page-designer",
  page: "page-designer-page",
  title: "page-designer-title",
  gridSize: "page-designer-grid-size",
  snapToggle: "page-designer-snap-toggle",
  alignLeftBtn: "page-designer-align-left",
  alignRightBtn: "page-designer-align-right",
  alignTopBtn: "page-designer-align-top",
  alignBottomBtn: "page-designer-align-bottom",
  alignCenterHorizontalBtn: "page-designer-align-center-horizontal",
  alignCenterVerticalBtn: "page-designer-align-center-vertical",
  distributeHorizontalBtn: "page-designer-distribute-horizontal",
  distributeVerticalBtn: "page-designer-distribute-vertical",
  sameWidthBtn: "page-designer-same-width",
  sameHeightBtn: "page-designer-same-height",
  sameSizeBtn: "page-designer-same-size",
  addCardBtn: "page-designer-add-card",
  saveBtn: "page-designer-save",
  loadBtn: "page-designer-load",
  resetBtn: "page-designer-reset",
  previewBtn: "page-designer-preview",
  previewExitBtn: "page-designer-back-to-designer",
  canvas: "page-designer-canvas",
  colAxis: "page-designer-col-axis",
  rowAxis: "page-designer-row-axis",
  cell: "page-designer-cell",
  card: "page-designer-card",
  dragHandle: "page-designer-drag-handle",
  resizeHandle: "page-designer-resize-handle",
  properties: "page-designer-properties",
  propertiesTab: "page-designer-properties-tab",
  layoutTab: "page-designer-layout-tab",
  selectedName: "page-designer-selected-name",
  posCol: "page-designer-pos-col",
  posRow: "page-designer-pos-row",
  sizeWidth: "page-designer-size-width",
  sizeHeight: "page-designer-size-height",
  sizeWidthPx: "page-designer-size-width-px",
  sizeHeightPx: "page-designer-size-height-px",
  styleBackground: "page-designer-style-background",
  styleBorder: "page-designer-style-border",
  layoutStack: "page-designer-layout-stack",
  status: "page-designer-status",
  sectionContent: "page-designer-section-content",
  sectionBehavior: "page-designer-section-behavior",
  sectionPosition: "page-designer-section-position",
  sectionManage: "page-designer-section-manage",
  sectionStyle: "page-designer-section-style",
  contentType: "page-designer-content-type",
  behavior: "page-designer-behavior",
  contentSoon: "page-designer-content-soon",
  behaviorSoon: "page-designer-behavior-soon",
  addCardBtnPanel: "page-designer-add-card-panel",
  removeCardBtn: "page-designer-remove-card",
  duplicateCardBtn: "page-designer-duplicate-card",
  removeDialog: "page-designer-remove-dialog",
  removeDialogTitle: "page-designer-remove-title",
  removeCancel: "page-designer-remove-cancel",
  removeConfirm: "page-designer-remove-confirm",
  rtf: "page-designer-rtf",
  rtfToolbar: "page-designer-rtf-toolbar",
  rtfEditor: "page-designer-rtf-editor",
  rtfPreview: "page-designer-rtf-preview",
  rtfBold: "page-designer-rtf-bold",
  rtfItalic: "page-designer-rtf-italic",
  rtfUnderline: "page-designer-rtf-underline",
  rtfFontSize: "page-designer-rtf-font-size",
  rtfAlignLeft: "page-designer-rtf-align-left",
  rtfAlignCenter: "page-designer-rtf-align-center",
  rtfAlignRight: "page-designer-rtf-align-right",
  rtfBullet: "page-designer-rtf-bullet",
  rtfNumber: "page-designer-rtf-number",
  addContentBtn: "page-designer-add-content",
  addContentDialog: "page-designer-add-content-dialog",
  addContentTable: "page-designer-add-content-table",
  configureTableBtn: "page-designer-configure-table",
  tableBuilder: "page-designer-table-builder",
  tableSource: "page-designer-table-source",
  tableAvailable: "page-designer-table-available",
  tableSelected: "page-designer-table-selected",
  tableColAdd: "page-designer-table-col-add",
  tableColRemove: "page-designer-table-col-remove",
  tableColUp: "page-designer-table-col-up",
  tableColDown: "page-designer-table-col-down",
  tableTitle: "page-designer-table-title",
  tableSortColumn: "page-designer-table-sort-column",
  tableSortDirection: "page-designer-table-sort-direction",
  tableMaxRows: "page-designer-table-max-rows",
  tablePreviewPatient: "page-designer-table-preview-patient",
  tableBuilderSave: "page-designer-table-builder-save",
  tableBuilderCancel: "page-designer-table-builder-cancel",
  tableBuilderNext: "page-designer-table-builder-next",
  tableBuilderBack: "page-designer-table-builder-back",
  tableContent: "page-designer-table-content",
  tableHeading: "page-designer-table-heading",
  tableGrid: "page-designer-table-grid",
};
